// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  api_url: 'https://autoswsarg.chubblatinamerica.com/portalesArgBff/api',
  azureAD: {
    host: 'auth.chubb.com',
    tenantName: 'auth.chubb.com',
    url: 'https://auth.chubb.com/auth.chubb.com/v2.0/.well-known/openid-configuration?p=B2C_1A_PortalAutoArgentina_LATAM_LocalAccount_AADSIGNIN_AT',
    redirectUri: "https://autoswsarg.chubblatinamerica.com/brokerchannel/acceso/",
    responseType: 'token id_token',
    strictDiscoveryDocumentValidation: false,
    issuer: 'https://auth.chubb.com/cb529fac-32b1-4bed-9c5e-378df8608a2c/v2.0/',
    tokenEndpoint: 'https://auth.chubb.com/auth.chubb.com/oauth2/v2.0/token?p=B2C_1A_PortalAutoArgentina_LATAM_LocalAccount_AADSIGNIN_AT',
    loginUrl: 'https://auth.chubb.com/auth.chubb.com/oauth2/v2.0/authorize?p=B2C_1A_PortalAutoArgentina_LATAM_LocalAccount_AADSIGNIN_AT',
    logoutUrl: 'https://auth.chubb.com/auth.chubb.com/oauth2/v2.0/logout?p=B2C_1A_PortalAutoArgentina_LATAM_LocalAccount_AADSIGNIN_AT',
    clientId: 'c538c075-2286-4cf5-a00c-539e790afe61',
    scope: 'openid https://auth.chubb.com/PortalAutoArgentina_LATAM_BSN0019031_API/read',
    clearHashAfterLogin: false,
    resetPolicy: 'B2C_1A_PortalAutoArgentina_LATAM_LocalAccount_Resetpassword_AT',
    silentRefreshRedirectUri: window.location.origin + '/brokerchannel',
    showDebugInformation: false
  },
  tokenexConfig: {
    origin: window.location.origin,
    tokenExID: "3085093868623131",
    tokenScheme: "PCI",
    pci: true,
    debug: false,
    enableValidateOnBlur: true,
    enablePrettyFormat: true,
    inputType: "number",
    maskInput: true,
    styles: {
      base: "height: 22px;border-radius: 4.2px;border: solid 1px #dbdbdb;background-color: white;font-size: 16px;font-size: 1.33333333rem;font-weight: 400;letter-spacing: normal;padding: 11px 17px;display: flex;order: 1;",
      focus: "box-shadow: 0 0 6px 0 rgba(0, 132, 255, 0.5);border: 1px solid rgba(0, 132, 255, 0.5);outline: 0;",
      error: "box-shadow: 0 0 6px 0 rgba(224, 57, 57, 0.5);border: 1px solid rgba(224, 57, 57, 0.5);",
    },
    placeholder: "Número de Tarjeta"
  }
};